const { FunRun = {} } = typeof window !== 'undefined' ? window : {}

export const currentApplication = FunRun.current_application || {}
export const servicesApiUrl = FunRun.services_api_url || ''
export const bugsnagConfig = FunRun.bugsnag_config || {}

export default currentApplication
